import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form, Checkbox } from 'semantic-ui-react'

/**
 * CheckboxFilter
 *
 * Simple boolean checkbox filter.
 * Used for EDI filter.
 */
export const CheckboxFilter = ({
  value,
  onChange,
  label,
  checkedLabel,
  uncheckedLabel,
}) => {
  const handleChange = (e, { checked }) => {
    onChange(checked)
  }

  const wrapperRef = useRef(null)

  useEffect(() => {
    const input = wrapperRef.current.querySelector('input[type="checkbox"]')
    input.setAttribute('data-testid', 'marketplace-filters-edi-checkbox')
  }, [])

  const displayLabel = value ? checkedLabel : uncheckedLabel

  return (
    <Form.Field>
      <label>{label}</label>
      <span ref={wrapperRef}>
        <Checkbox
          checked={Boolean(value)}
          onChange={handleChange}
          label={displayLabel}
        />
      </span>
    </Form.Field>
  )
}

CheckboxFilter.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  checkedLabel: PropTypes.string,
  uncheckedLabel: PropTypes.string,
}

CheckboxFilter.defaultProps = {
  value: false,
  label: 'Filter',
  checkedLabel: 'Enabled',
  uncheckedLabel: 'Disabled',
}
